import instObj from '@/backend/axios-instances'

const resource = "/workstations/queue"
const instance = instObj.baseInstance

export default {
  get(queueId, parameters) {
    return instance.get(`${resource}/${queueId}`, { params: parameters });
  },
  put(queueId, data, parameters) {
    return instance.put(`${resource}/${queueId}`, data, { params: parameters });
  },
  delete(queueId) {
    return instance.delete(`${resource}/${queueId}`);
  }
}
